<template lang="pug">
  .mb-3
    img.img-fluid(:src="value" @click="openModal()" v-if="value")
    .select-image(v-else @click="openModal()")
    form_error(:errors="errors?errors[name.replace('select-','')]:[]")
    .modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true' :id="name")
      .modal-dialog.modal-dialog-centered(role='document' :class="modal_class")
        .modal-content
          .modal-header
            h5.modal-title Select Image
            button.close(type='button' data-dismiss='modal' aria-label='Close') x
          .modal-body
            input(type="file" @change="croppie")
            vue-croppie(ref='croppieRef' :enableorientation='false' :enableResize='false' :boundary='{ width: w+100, height: h+100}' :viewport="{ width: w, height: h }" v-if="imageSelected")
          .modal-footer
            button.btn.btn-secondary.mr-auto(type='button' data-dismiss='modal') Close
            button.btn.btn-primary(type='button' data-dismiss='modal' @click="crop()") Crop
</template>

<script>
import form_error from '@/components/formErrors';
import { mapState } from 'vuex';
export default {
  props: {
    'h': {
      default: 100
    }, 
    'w': {
      default: 200
    }, 
    'value': {
      default: ''
    },
    'modal_class': {
      default: ''
    },
    'name': {
      default: 'model-simple'
    }
  },  
  components:{
    form_error
  },
  data(){
    return {
      imageSelected: false,
    }
  },
  computed:{
    ...mapState('api', ['errors'])
  },
  methods: {
    croppie (e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = e => {
        this.$refs.croppieRef.bind({
          url: e.target.result
        });
      };

      reader.readAsDataURL(files[0]);
      this.imageSelected=true;
    },
    crop() {
      var vm = this;
        // Here we are getting the result via callback function
        // and set the result to this.cropped which is being 
        // used to display the result above.
        let options = {
            format: 'png',
        }
        this.$refs.croppieRef.result(options, (output) => {
            this.$emit('input', output);
        });
    },
    openModal(){
      $('#'+this.name).modal('show')
    },
  }
}
</script>

<style lang="scss" scoped>
.select-image{
  width: 100%;
  height: 200px;
  border: 2px dashed #222;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  &::before{
    content: 'Select Image';
    font-size: 2rem;
  }
}
</style>